export interface Course {
  id: string;
  name: string;
  level: 'beginner' | 'intermediate' | 'advanced';
  duration: string;
  schedule: string;
  price: number;
  description: string;
  features: string[];
}

export const initialCourses: Course[] = [
  // Beginner
  {
    id: '1',
    name: '기초 영어 A반',
    level: 'beginner',
    duration: '3개월',
    schedule: '월/수/금 19:00-21:00',
    price: 450000,
    description: '영어 학습을 처음 시작하는 분들을 위한 기초 과정',
    features: [
      '기초 문법 완벽 정리',
      '필수 어휘 1000개 학습',
      '간단한 일상 회화',
      '발음 교정 프로그램'
    ]
  },
  {
    id: '2',
    name: '기초 영어 B반',
    level: 'beginner',
    duration: '3개월',
    schedule: '화/목 19:00-22:00',
    price: 450000,
    description: '기본 문법을 익히고 간단한 회화를 연습하는 과정',
    features: [
      '실용 문법 학습',
      '생활 영어 표현',
      '듣기 훈련',
      '쓰기 기초'
    ]
  },
  // Intermediate
  {
    id: '3',
    name: '중급 회화반',
    level: 'intermediate',
    duration: '4개월',
    schedule: '월/수/금 19:00-21:00',
    price: 550000,
    description: '일상 회화부터 비즈니스 기초 회화까지',
    features: [
      '원어민과 1:1 회화',
      '주제별 토론 연습',
      '프레젠테이션 훈련',
      '실전 회화 시뮬레이션'
    ]
  },
  {
    id: '4',
    name: 'TOEIC 정규반',
    level: 'intermediate',
    duration: '2개월',
    schedule: '화/목/토 18:00-21:00',
    price: 600000,
    description: 'TOEIC 700점 이상 목표 달성 과정',
    features: [
      '파트별 전략 학습',
      '매주 실전 모의고사',
      '개인별 약점 보완',
      '고득점 비법 전수'
    ]
  },
  {
    id: '5',
    name: 'TOEFL 대비반',
    level: 'intermediate',
    duration: '3개월',
    schedule: '월/수/금 18:00-21:00',
    price: 700000,
    description: 'TOEFL iBT 80점 이상 목표 과정',
    features: [
      'Speaking 집중 훈련',
      'Writing 첨삭 지도',
      '독해 스킬 향상',
      '청해 실전 연습'
    ]
  },
  // Advanced
  {
    id: '6',
    name: '고급 비즈니스 영어',
    level: 'advanced',
    duration: '3개월',
    schedule: '화/목 19:00-22:00',
    price: 800000,
    description: '실무에서 바로 활용 가능한 비즈니스 영어',
    features: [
      '이메일 작성 마스터',
      '회의 진행 영어',
      '협상 기술',
      '리포트 작성법'
    ]
  },
  {
    id: '7',
    name: '고급 회화 마스터',
    level: 'advanced',
    duration: '4개월',
    schedule: '월/수/금 19:00-21:00',
    price: 900000,
    description: '원어민 수준의 유창한 영어 구사 목표',
    features: [
      '고급 어휘 학습',
      '자연스러운 표현',
      '문화적 뉘앙스',
      '토론 및 발표'
    ]
  },
  {
    id: '8',
    name: 'TOEIC 900+ 특강',
    level: 'advanced',
    duration: '2개월',
    schedule: '토/일 10:00-17:00',
    price: 1000000,
    description: 'TOEIC 900점 이상을 위한 집중 과정',
    features: [
      '고난도 문제 풀이',
      '만점 전략',
      '시간 관리 기술',
      '실전 모의고사 10회'
    ]
  }
];

export const getAllCourses = (): Course[] => {
  if (typeof window === 'undefined') return initialCourses;

  const stored = localStorage.getItem('courseData');
  if (!stored) {
    localStorage.setItem('courseData', JSON.stringify(initialCourses));
    return initialCourses;
  }
  return JSON.parse(stored);
};

export const getCoursesByLevel = (level: string): Course[] => {
  const courses = getAllCourses();
  return courses.filter(course => course.level === level);
};

export const getCourseById = (id: string): Course | undefined => {
  const courses = getAllCourses();
  return courses.find(course => course.id === id);
};

export const addCourse = (course: Course) => {
  const courses = getAllCourses();
  courses.push(course);
  localStorage.setItem('courseData', JSON.stringify(courses));
};

export const updateCourse = (id: string, updatedCourse: Course) => {
  const courses = getAllCourses();
  const index = courses.findIndex(course => course.id === id);
  if (index !== -1) {
    courses[index] = updatedCourse;
    localStorage.setItem('courseData', JSON.stringify(courses));
  }
};

export const deleteCourse = (id: string) => {
  const courses = getAllCourses();
  const filtered = courses.filter(course => course.id !== id);
  localStorage.setItem('courseData', JSON.stringify(filtered));
};
